import type { TrackedTranslation, TranslationTag } from '@swf/core/types/i18n';

export enum PageType {
  Eula = 'eula',
  Privacy = 'privacy',
  PFP = 'pfp'
}

export interface PageContentTypes {
  link: string;
  title: TrackedTranslation | TranslationTag;
}
